import React, { useCallback, useEffect, useState } from 'react';
import { Spin } from 'antd';
import { useSelector } from 'react-redux';
import styles from './career-preference.module.scss';
import talentProfileApi from '../../services/talentProfiles';
import { TP_PRINT_SECTION_NAME } from '../TalentProfilePrintPreview/constants';

const INIT_DATA = {
  next_career_move: '',
  preferred_job_family: '',
  preferred_job_function: '',
  preferred_region: '',
  preferred_job_description: '',
  comments: '',
};

const CareerPreference = (props) => {
  const { profileId, tokenTalentProfile } = props;
  const user = useSelector((state) => state.user);
  const [careerPreference, setCarrerPreference] = useState(INIT_DATA);
  const [loading, setLoading] = useState(false);

  const fetchApi = useCallback(async () => {
    if (!user.roleActive) return;
    try {
      setLoading(true);
      const response = await talentProfileApi.fetchCareerPreferenceStatus({
        profileId,
        roleUser: user,
        tokenTalentProfile,
      });
      if (response.status === 200) {
        const result = response?.data?.result;
        setCarrerPreference(result || INIT_DATA);
      }
    } catch (error) {
      setCarrerPreference(INIT_DATA);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.roleActive.roleId, profileId]);

  useEffect(() => {
    fetchApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchApi]);

  return (
    <div className={styles.SectionPlan} data-print-section={TP_PRINT_SECTION_NAME.CAREER_PREFERENCES}>
      <div className={styles.SectionName}>
        <span>Career Preferences</span>
      </div>
      <Spin spinning={loading} size="small">
        <div className={styles.tablePlan}>
          <table className="table table-borderless">
            <thead className={styles.header}>
              <tr className={styles.tablePlanRow}>
                <th className={styles.leftItem}>
                  <span>Item</span>
                </th>
                <th className={styles.rightItem}>
                  <span>Details</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className={styles.tablePlanRow}>
                <th scope="row" className={styles.leftItem}>
                  Next Career Move
                </th>
                <td className={styles.rightItem}>{careerPreference.next_career_move || '-'}</td>
              </tr>
              <tr className={styles.tablePlanRow}>
                <th scope="row" className={styles.leftItem}>
                  Preferred Job Family
                </th>
                <td className={styles.rightItem}>{careerPreference.preferred_job_family || '-'}</td>
              </tr>
              <tr className={styles.tablePlanRow}>
                <th scope="row" className={styles.leftItem}>
                  Preferred Job Function
                </th>
                <td className={styles.rightItem}>{careerPreference.preferred_job_function || '-'}</td>
              </tr>
              <tr className={styles.tablePlanRow}>
                <th scope="row" className={styles.leftItem}>
                  Preferred Region
                </th>
                <td className={styles.rightItem}>{careerPreference.preferred_region || '-'}</td>
              </tr>
              <tr className={styles.tablePlanRow}>
                <th scope="row" className={styles.leftItem}>
                  Preferred Job Description
                </th>
                <td className={styles.rightItem}>{careerPreference.preferred_job_description || '-'}</td>
              </tr>
              <tr className={styles.tablePlanRow}>
                <th scope="row" className={styles.leftItem}>
                  Comments
                </th>
                <td className={styles.rightItem}>{careerPreference.comments || '-'}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Spin>
    </div>
  );
};

export default CareerPreference;
